import { Component, ViewChild } from '@angular/core';
import {ModalController, Nav, NavController, Platform, ViewController} from 'ionic-angular';

import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import {ServerProvider} from "../providers/server/server";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = HomePage;

  constructor( public server: ServerProvider, public platform: Platform, public modalCtrl: ModalController) {
    if( !localStorage.getItem('token') ){
      let modal = this.modalCtrl.create( LoginPage );
      modal.present();
    } else{
      this.server.get( 'active' ).subscribe( (data:any)=>{
        this.server.user = data.data;
        this.server.getCases();
      }, err=>{
        let modal = this.modalCtrl.create( LoginPage );
        modal.present();
      });
    }
  }

  open( key ){
    this.nav.push( HomePage );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts